var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.generalTableData)?_c('JindiaoTable',{attrs:{"data":_vm.generalTableData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }